  const API_URL= process.env.REACT_APP_API_URL || 'http://localhost:3000';
  const VERSION= process.env.REACT_APP_VERSION || 'v1';
  const APP_NAME= process.env.REACT_APP_APP_NAME || 'Cornerstone Consulting';
  const APP_VERSION=  process.env.REACT_APP_APP_VERSION || '1.0.0';
  const DEBUG= process.env.REACT_APP_DEBUG === 'true';
  const ENV:"development" | "production" = (process.env.REACT_APP_ENV as 'development' | 'production') || 'development';

export { API_URL, APP_NAME, APP_VERSION, DEBUG, ENV, VERSION };
